import { render, staticRenderFns } from "./ModalEditReport.vue?vue&type=template&id=0d351566&scoped=true"
import script from "./ModalEditReport.vue?vue&type=script&lang=js"
export * from "./ModalEditReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d351566",
  null
  
)

export default component.exports